import React from 'react';
import HeroSection from './component/HeroSection';
import Educations from './component/Educations'
import Skills from './component/Skills'

const aboutData = {
  subhead: "WHO I AM",
  name: "Venkatesh Moyya",
  image: "./images/about.jpg",
  myInfo: (
    <p>
      I am a passionate <strong>Full-Stack Developer and Technical Trainer</strong>, leveraging deep expertise in the <strong>MERN stack</strong> (MongoDB, Express.js, React.js, Node.js) and Python to build high-quality applications and mentor the next generation of developers.
      <br /><br />
      With extensive experience as a technical educator and freelancer, I have trained <strong>2000+ students</strong> in full-stack web development, DSA, and problem-solving, equipping them with hands-on coding skills and practical knowledge. I currently work as a Technical Mentor & DSA Instructor at ByteXL.
      <br /><br />
      <strong>Industry Collaborations:</strong> I have partnered with companies like Coign, Six Phrase, Talentio, CodeNow, IEXCEL Learning Solutions, and Vegaahi IT to deliver customized training programs and bootcamps.
      <br /><br />
      <strong>Expertise:</strong> React.js, Node.js, MongoDB, Python, DSA, scalable application development, and modern web technologies.
    </p>
  ), 
}

const About = () => {
  return (
    <>
      <HeroSection {...aboutData} />
      <div className="about-section">
        <div className="common-heading">
          <p className='common-subheading mb-2'>My Educations & Skills</p>
          <h1>More About Me</h1>
        </div>

        <div className="card-container grid grid-two-column ">
          <Educations />
          <Skills />
        </div>
      </div>
    </>
  )
}

export default About
